import { useContext, useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { ApiContext } from '../App';
import { UserContext } from '../App';
import { EntitiesContext } from '../App';
import * as ActionTypes from '../constants/action-types';

const options = {}
const resource = 'orders';

export const useCreateOrder = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);
  const sale = entities.state.get('sale').find(s => s.open);

  return useMutation(order => api.post(`/${resource}`, order.set('sale_id', sale.id)), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITY,
      payload: data.data
    })
  });
}

export const useUpdateOrder = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(order => api.put(`/${resource}/${order.id}`, order), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITY,
      payload: data.data
    })
  });
}

export const useDeleteOrder = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(order => api.delete(`/${resource}/${order.id}`), {
    onMutate: item => entities.dispatch({
      type: ActionTypes.CLEAR_ENTITY,
      payload: {
        type: resource,
        id: item.id
      }
    })
  })
}

export const useGetOrder = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  const orders = useQuery('order', () => api.get(`/${resource}`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: data.data
    })
  });

  return orders;
}

export const useGetOrderItems = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(order => api.get(`/${resource}/${order.id}/inventory`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: data.data
    })
  })
}

export const useFindOrder = id => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useQuery(['find', id], () => api.get(`/${resource}/${id}`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITY,
      payload: data.data
    })
  });
}

export const usePollOrder = (id, refetch, onSuccess) => {
  const api = useContext(ApiContext);
  const [stop, setStop] = useState(false);
  const [counter, setCounter] = useState(0);

  return useQuery('poll', () => api.get(`/${resource}/${id}`), {
    cacheTime: 100,
    enabled: id !== null,
    refetchInterval: stop ? false : refetch,
    onSuccess: onSuccess,
    onSettled: () => {
      setCounter(counter + 1);

      // failsafe: don't let this refetch more than 20x
      if (counter >= 20) setStop(true);
    },
    onError: () => setStop(true)
  });
}
